import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "remixicon/fonts/remixicon.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast_config } from "./utils/constants";
import Header from "./Modules/Common/Header/Header";
import Footer from "./Modules/Common/Footer/Footer";
import LandingPage from "./Modules/Common/LandingPage/LandingPage";
import UserLogin from "./Modules/Common/Login/UserLogin";
import UserRegistration from "./Modules/Common/Registration/UserRegistration";
import VendorRegistration from "./Modules/Common/Registration/VendorRegistration";
import VendorListingPage1 from "./Modules/Common/Vendor/VendorListingPage1";
import VendorListingPage from "./Modules/Common/Vendor/VendorListingPage";
import VendorInfoPage from "./Modules/Common/Vendor/VendorInfoPage";
import ContactUs from "./Modules/Common/ContactUs/ContactUs";
import FourNotFour from "./Modules/Common/FourNotFour/FourNotFour";
import PrivateRoute from "./routers/PrivateRoute";
import EventCoordinator from "./Modules/EventCoordinator/EventCoordinator";
import Admin from "./Modules/Admin/Admin";
import User from "./Modules/User/User";
import Vendor from "./Modules/Vendor/Vendor";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import useDashboardCheck from "../src/hooks/useDashboardCheck ";
import UserManagement from "./Modules/Admin/scenes/UserManagement/UserManagement";
import AdminMeetingManagement from "./Modules/Admin/MeetingManagement/AdminMeetingManagement";
import AdminBookingManagement from "./Modules/Admin/BookingManagement/AdminBookingManagement";
import VendorManagement from "./Modules/Admin/scenes/VendorManagement/VendorManagement";
import CoordinatorManagement from "./Modules/Admin/scenes/Co-ordinatorManagement/CoordinatorManagement";
import CreateCoordinator from "./Modules/Admin/scenes/Co-ordinatorManagement/CreateCoordinator";
import FAQ from "./Modules/Admin/scenes/faq/faq";
import VendorCategories from "./Modules/Admin/scenes/VendorManagement/VendorCategories";
import ServicesLocation from "./Modules/Admin/scenes/VendorManagement/ServicesLocation";
import PopularLocation from "./Modules/Admin/scenes/VendorManagement/PopularLocation";
import Contacts from "./Modules/Admin/scenes/contacts/Contacts";
import VendorServices from "./Modules/Admin/scenes/VendorManagement/VendorServices/VendorServices1";
import Profile from "./Modules/Vendor/VendorScenes/Profile/Profile";
import AddService from "./Modules/Vendor/VendorScenes/Service/AddService";
import ForgotForm from "./Modules/Common/Login/ForgotForm";
import ForgotOtp from "./Modules/Common/Login/ForgotOtp";
import LoginOtp from "./Modules/Common/Login/LoginOtp";
import CoordinatorProfile from "./Modules/EventCoordinator/EventCoordinatorScenes/CoordinatorProfile";
import EventInquiry from "./Modules/EventCoordinator/EventCoordinatorScenes/User InQuiry/EventInquiry";
import BudgetTool from "./Modules/Common/BudgetTool/BudgetTool";
import UpdateBudgetTool from "./Modules/Common/BudgetTool/updateBudgetTool";
import AdminAuthentication from "./Modules/Common/Login/AdminAuthentication";
import EventCoordinatorListing from "./Modules/EventCoordinator/EventCoordinatorListing";
import Services from "./Modules/Vendor/VendorScenes/Service/Services";
import CoordinatorCards from "./Modules/Common/CoorinatorCards/CoordinatorCards";
import Calendar from "./Modules/Admin/scenes/calendar/AdminCalendar";
import EventCalendar from "./Modules/EventCoordinator/EventCoordinatorScenes/calendar/EventCalendar";
import VendorCategorys from "./Modules/Common/VendorCategorys/VendorCategorys";
import Notification from "./utils/Notification";
import { SocketProvider, useSocket } from "./utils/SocketContext";
import { QueryClient, QueryClientProvider } from "react-query";
import AddVendorForm from "./Modules/EventCoordinator/EventCoordinatorScenes/User InQuiry/AddVendorForm";
import Support from "./Modules/Admin/scenes/Support/Support";
import CoordinatorProfiles from "./Modules/Admin/scenes/Co-ordinatorManagement/CoordinatorProfiles";
import EventMaster from "./Modules/Admin/scenes/Event/EventMaster";
import ChangeCoordinator from "./Modules/Admin/scenes/Event/ChangeCoordinator";
import VendorEvents from "./Modules/Vendor/VendorScenes/VendorEvents/VendorEvents";
import VendorCalendar from "./Modules/Vendor/VendorScenes/calendar/VendorCalendar";
import MyCalendar from "./Modules/Common/Calender/MyCalendar";
import CheckList from "./Modules/Common/CheckList/CheckList";
import SearchVendors from "./Modules/Common/BudgetTool/SearchVendors";
import AddNote from "./Modules/EventCoordinator/EventCoordinatorScenes/User InQuiry/AddNote";
import VendorDetails from "./Modules/Common/Vendor/vendorDetailsPage";
import AboutUs from "./Modules/Common/AboutUs/AboutUs";
import VendorBooking from "./Modules/Vendor/VendorScenes/VendorBooking/VendorBooking";
import EventBooking from "./Modules/EventCoordinator/EventCoordinatorScenes/EventBooking/EventBooking";
import GuestList from "./Modules/Common/Content/GuestList/guestList";
import VendorTokenPage from "./Modules/Vendor/VendorTokenPage";
import EventTokenPage from "./Modules/EventCoordinator/EventCoordinatorScenes/EventTokenPage";
import Servicesone from "./Modules/Vendor/VendorScenes/Service/Serviceone";
import PremiumVendors from "./Modules/Admin/scenes/VendorManagement/PremiumVendors";
import SiteInProgress from "./Modules/Common/Content/SiteInProgress";
import RecommendationPage from "./Modules/EventCoordinator/EventCoordinatorScenes/EventRecommendation/EventRecommendation";
import PrivacyPolicy from "./Modules/Common/Content/Company-Policies/Privacy_Policy";
import TermsOfUse from "./Modules/Common/Content/Company-Policies/Terms-of-use";
import VisionMissionPage from "./Modules/Common/Content/Company-Policies/Vision-Mission";
import VendorCalendarOut from "./Modules/Vendor/VendorScenes/calendar/VendorCalendarOut";
import AdminCalendar from "./Modules/Admin/scenes/calendar/AdminCalendar";
import CoordinatorGuestList from "./Modules/EventCoordinator/EventCoordinatorScenes/User InQuiry/CoordinatorGuestList";
import GuestLogin from "./Modules/Common/Content/GuestList/GuestLoginPage";
import GuestFormComponent from "./Modules/Common/Content/GuestList/guestFormComponent";
import WeddingHashtagGenerator from "./Modules/Common/HashtagGenerator/HastagGenerator";
import WeddingIdeasPage from "./Modules/Common/Blog/Blog";

// Initialize React Query Client
const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    AOS.init({ duration: 650, once: true });
  }, []);

  const location = useLocation();
  const isDashboardRoute = useDashboardCheck();
  const isSiteInProgress = location.pathname === "/";
  const token = secureLocalStorage.getItem("token");
  let role = null;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      role = decoded ? decoded.role : null;
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }

  const socket = useSocket();

  useEffect(() => {
    if (socket && token) {
      try {
        const decoded = jwtDecode(token);
        const userId = decoded ? decoded._id : null;
        socket.emit("register", userId);
        socket.on("notification", (data) => {
          console.log("Notification received:", data);
        });
        return () => {
          socket.off("notification");
        };
      } catch (error) {
        console.error("Error in socket handling:", error);
      }
    }
  }, [socket, token]);

  // Check if the current path is an admin, vendor, or coordinator route
  const isAdminRoute = location.pathname.startsWith("/admin-dashboard");
  const isVendorRoute = location.pathname.startsWith("/vendor-dashboard");
  const isCoordinatorRoute = location.pathname.startsWith(
    "/co-ordinator-dashboard"
  );
  // const showHeaderFooter =
  //   !isSiteInProgress &&
  //   (!isDashboardRoute ||
  //     (!isAdminRoute &&
  //       !isVendorRoute &&
  //       !isCoordinatorRoute &&
  //       !["VENDOR", "ADMIN", "CO-ORDINATOR"].includes(role)));
  const showHeaderFooter =
    !isDashboardRoute ||
    (!isAdminRoute &&
      !isVendorRoute &&
      !isCoordinatorRoute &&
      !["VENDOR", "ADMIN", "CO-ORDINATOR"].includes(role));

  return (
    <div>
      <Notification />
      <ToastContainer {...toast_config} />

      {showHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* <Route path="/" element={<SiteInProgress />} /> */}

        <Route path="/login" element={<UserLogin />} />
        <Route path="/approveVendorService" element={<VendorTokenPage />} />
        <Route
          path="/approveEventBookingManagement"
          element={<EventTokenPage />}
        />
        <Route path="/Forgot-Password" element={<ForgotForm />} />

        <Route path="/Verify-Otp" element={<LoginOtp />} />
        <Route path="/Forgot-Otp" element={<ForgotOtp />} />
        <Route path="/Admin-Authentication" element={<AdminAuthentication />} />

        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/vendor-registration" element={<VendorRegistration />} />
        <Route path="/vendor-list1" element={<VendorListingPage1 />} />
        <Route path="/vendor-list" element={<VendorListingPage />} />
        <Route path="/vendor-info" element={<VendorInfoPage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/About" element={<AboutUs />} />
        <Route path="/Terms_Of_use" element={<TermsOfUse />} />
        <Route path="/Privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/Vision_Mission" element={<VisionMissionPage />} />
        <Route path="/Calendar" element={<MyCalendar />} />

        {/* <Route path="/contact-us" element={<ContactUs />} /> */}
        <Route path="/Calendars" element={<MyCalendar />} />
        <Route path="/CheckList-Page" element={<CheckList />} />
        <Route path="/SearchVendor-Page" element={<SearchVendors />} />
        <Route path="/GuestLogin" element={<GuestLogin />} />
        <Route path="/GuestFormPage" element={<GuestFormComponent />} />
        <Route path="/wedding-hashtag-generator" element={<WeddingHashtagGenerator />} />
        <Route path="/Blogs" element={<WeddingIdeasPage />} />

        <Route path="*" element={<FourNotFour />} />
        <Route path="/faq" element={<FAQ />} />
        <Route
          path="/user-dashboard"
          element={
            <PrivateRoute roles={["USER"]}>
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="/user/guest-list"
          element={
            <PrivateRoute roles={["USER"]}>
              <GuestList />
            </PrivateRoute>
          }
        />
        <Route
          path="/Budget-tool"
          element={
            <PrivateRoute roles={["USER"]}>
              <BudgetTool />
            </PrivateRoute>
          }
        />
        <Route
          path="/view&update-Budget-tool"
          element={
            <PrivateRoute roles={["USER"]}>
              <UpdateBudgetTool />
            </PrivateRoute>
          }
        />
        <Route
          path="/vendor-details/:id"
          element={
            <PrivateRoute roles={["USER", "ADMIN", "VENDOR", "COORDINATOR"]}>
              <VendorDetails />
            </PrivateRoute>
          }
        />
        <Route path="/Vendor-Categorys" element={<VendorCategorys />} />
        <Route
          path="/EventCoordinator-list"
          element={
            <PrivateRoute roles={["USER"]}>
              <EventCoordinatorListing />
            </PrivateRoute>
          }
        />
        <Route
          path="/co-ordinator-dashboard"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]}>
              <EventCoordinator />
            </PrivateRoute>
          }
        />
        <Route
          path="/co-ordinator-dashboard/Profile"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <CoordinatorProfile />
            </PrivateRoute>
          }
        />

        <Route
          path="/co-ordinator-dashboard/User-InQuiry"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <EventInquiry />
            </PrivateRoute>
          }
        />

        <Route
          path="/co-ordinator-dashboard/Add-VendorForm"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <AddVendorForm />
            </PrivateRoute>
          }
        />

        <Route
          path="/co-ordinator-dashboard/EventBooking"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <EventBooking />
            </PrivateRoute>
          }
        />
        <Route
          path="/co-ordinator-dashboard/calendar"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <EventCalendar />
            </PrivateRoute>
          }
        />
        <Route
          path="/co-ordinator-dashboard/recommendations"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <RecommendationPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/co-ordinator-dashboard/Add-Note"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <AddNote />
            </PrivateRoute>
          }
        />
        <Route
          path="/co-ordinator-dashboard/Coordinator-guest-list"
          element={
            <PrivateRoute roles={["CO-ORDINATOR"]} dashboardRoute>
              <CoordinatorGuestList />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard"
          element={
            <PrivateRoute roles={["VENDOR"]}>
              <Vendor />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/Profile"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/AddService"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <AddService />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/Serviceone"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <Servicesone />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/Service"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <Services />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/VendorEvents"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <VendorEvents />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/VendorBooking"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <VendorBooking />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendor-dashboard/VendorCalendar"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <VendorCalendar />
            </PrivateRoute>
          }
        />
        <Route
          path="/vendor-dashboard/VendorCalendarOut"
          element={
            <PrivateRoute roles={["VENDOR"]} dashboardRoute>
              <VendorCalendarOut />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <Admin />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/user-management"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <UserManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/vendor-management"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <VendorManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/booking-management"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <AdminBookingManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/meeting-management"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <AdminMeetingManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/vendor-categories"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <VendorCategories />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/premium-vendors"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <PremiumVendors />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/vendor-services"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <VendorServices />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/services-location"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <ServicesLocation />
            </PrivateRoute>
          }
        />
         <Route
          path="/admin-dashboard/Popular-location"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <PopularLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/coordinator-management"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <CoordinatorManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/create-coordinator"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <CreateCoordinator />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/contacts"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <Contacts />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin-dashboard/Support"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <Support />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/AdminCalendar"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <AdminCalendar />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/CoordinatorProfiles"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <CoordinatorProfiles />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/EventMaster"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <EventMaster />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-dashboard/ChangeCoordinator"
          element={
            <PrivateRoute roles={["ADMIN"]}>
              <ChangeCoordinator />
            </PrivateRoute>
          }
        />
      </Routes>
      {showHeaderFooter && <Footer />}
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <ScrollToTop />
      <QueryClientProvider client={queryClient}>
        <SocketProvider>
          <App />
        </SocketProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default AppWrapper;
